import numeral from 'numeral';
import {convertToNegativeValueOfArray} from '../utils/utils';

export const overviewChartOptions = {
  responsive: true,
  chartArea: {
    backgroundColor: 'rgba(255, 255, 255)'
  },
  scales: {
    xAxes: [{
      ticks: {
        callback: (value) => {
            return numeral(value).format('$0,0.00');
        }
      }
    }]
  },
  "tooltips": {
    "enabled": true,
    "mode": "label",
    "intersect": false,
    "displayColors": false,
    "callbacks": {
      title: (tooltipItem, data) => {
        return '';
      },
      label: (tooltipItem, data) => {
        //console.log('tooltipItem', tooltipItem, 'data', data)
        let item = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
        let total = data.datasets[tooltipItem.datasetIndex].lineTension;
        return `${numeral(item).format('$0,0.00')}` ;
      },
    }
  }
}
export const chartOptions = {
  responsive: true,
  chartArea: {
    backgroundColor: 'rgba(255, 255, 255)'
  },
  scales: {
    xAxes: [{
      ticks: {
        callback: (value) => {
            return numeral(value).format('0,0');
        }
      }
    }]
  },
  "tooltips": {
    "enabled": true,
    "mode": "label",
    "intersect": false,
    "displayColors": false,
    "callbacks": {
      title: (tooltipItem, data) => {
        return '';
      },
      label: (tooltipItem, data) => {
        let item = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
        let total = data.datasets[tooltipItem.datasetIndex].lineTension;
        let percentage = numeral(item/total).format('0.00%');
        return `${numeral(item).format('0,0')} (${percentage})` ;
      },
    }
  }
}
export const pyramidChartOptions = {
  responsive: true,

  chartArea: {
    backgroundColor: 'rgba(255, 255, 255)'
  },
  scales: {
    xAxes: [{
      ticks: {
        callback: (value) => {
          if (value >=0) {
            return numeral(value).format('0,0');
          } else {
            return numeral(value * (-1)).format('0,0') ;
          }
            //return numeral(value).format('0,0');
        }
      }
    }],
    yAxes: [{
      stacked: true,


      scaleLabel: {
        fontSize: 60
      },
      ticks: {
        min: 0,
        minor: {
          fontColor: 'black'
        },
        major: {
          fontColor: 'yellow'
        },
        callback: (value) => {
          return value;
            //return numeral(value).format('0,0');
        }
      }
    }],
  },
  tooltips: {

    callbacks: {
      title: (tooltipItem, data) => {
        return '';
      },
      label: (tooltipItem, data) => {
        let item = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
        if (item <0 ) {
          item =  item * (-1);
        }
          
        
        const label = data.datasets[tooltipItem.datasetIndex].label;
          return `${label}: ${numeral(item).format('0,0')}` ;
      },
    }
  }
};

export const makeObjforPyramidChart = (inputObject) => {
  let output = {}
  let labels =[], males=[], females = []
  Object.entries(inputObject).forEach(([key, value]) => {
    //console.log('key', key, 'value', value, 'value.Males', value.Males, 'numeral', numeral(value.Males).value())
    labels.push(key)
    males.push(numeral(value.Males).value())
    females.push(numeral(value.Females).value()* (-1))
  })

  return {
    labels: labels.reverse(),
    males: males.reverse(),
    females: females.reverse()
  };

}
export const chartDataPyramid = (data, type) => {
  const pyramidData = makeObjforPyramidChart(data)
  //console.log('chartDataPyramid data', data, 'type', type, 'pyramidData', pyramidData)
 
  //console.log('chartDataPyramid females', getLineChartData(data, 'Females'))
  let chartData =  {
      labels: pyramidData.labels,
      datasets: [
        {
          label: 'Females',
          fill: false,
          backgroundColor: 'rgb(190, 0, 255)', 
          borderColor: 'rgb(152, 0, 204)',
          hoverBackgroundColor: 'rgba(95, 0, 127,0.4)',
          data: pyramidData.females

      },
      {
          label: 'Males',
          fill: false,
          backgroundColor: 'rgb(0, 74, 255)',
          borderColor: 'rgb(0, 59, 204)',
          hoverBackgroundColor: 'rgba(0, 37, 127,0.4)',
          data: pyramidData.males
      }
      ]
  }
  return chartData;
}

export const lineChartOptions = {
    responsive: true,
    chartArea: {
        backgroundColor: 'rgba(255, 255, 255)'
      },

    tooltips: {
      mode: 'label'
    },
    borderColor: 'red',
    hover: {
      mode: 'dataset'
    },
    scales: {
        xAxes: [
            {
              display: true,

            }
          ],
        yAxes: [{
            ticks: {
                beginAtZero: true,
                min: 0,
                callback: (value) => {
                    return numeral(value).format('0,0');
                }
            }
          }]
    },
    "tooltips": {
      "enabled": true,
      "mode": "label",
      "intersect": false,
      "displayColors": false,
      "callbacks": {
        title: (tooltipItem, data) => {
          return '';
        },
        label: (tooltipItem, data) => {
          //console.log('data', data)
          let item = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          const label = data.datasets[tooltipItem.datasetIndex].label
          const formattedNumber = (item % 1 != 0) ? item  : numeral(item).format('0,0')
          return `${label}: ${formattedNumber}` ;
        },
      }
    }
  }
export const chartOverview = {
    output: "Output ($m)",
    wages_salaries: "Wages Salaries ($m)",
    value_add: "Value Add ($m)",
    regional_imports: "Regional Imports ($m)",
    regional_exports: "Regional Exports ($m)"
}  

export const overviewChartData = (dataInput, overviewSelected) =>  {
  let labels, data;

  if (dataInput === undefined) {
    labels = []
    data = []
    
  } else {
    labels = dataInput.filter(item => {
      return item.parent_level === 'parent'
    }).map(item => {
      return item.category
    })
    data = dataInput.filter(item => {
      return item.parent_level === 'parent'
    }).map(item => {
      return item[overviewSelected]
    })
  }
  return {
      labels: labels,
      datasets: [
        {
          label: chartOverview[overviewSelected],
          backgroundColor: '#6baed6',
          borderColor: '#4292c6',
          borderWidth: 1,
          hoverBackgroundColor: '#2171b5',
          hoverBorderColor: '#08519c',
          data: data,
        }
      ]
  }
};

export const chartData = (dataInput, type, inputTotal, labelInput) =>  {
  let labels, data, label
  let total = inputTotal || 1;
  if (dataInput === undefined) {
    labels = []
    data = []
    label = ''
  } else {
    labels = dataInput.map(item => {
      return item[type]
    })
    data = dataInput.map(item => {
        return item.total
    })
    label = `${dataInput[0][labelInput]}`
  }

    return {
        labels: labels,
        datasets: [
          {
            label: label,
            backgroundColor: '#6baed6',
            borderColor: '#4292c6',
            borderWidth: 1,
            hoverBackgroundColor: '#2171b5',
            hoverBorderColor: '#08519c',
            data: data,
            lineTension: total // for now, use lineTension to store total value of a category
          }
        ]
    }
  };

export const getLabels = (data, type) => {
  //console.log('get labels data', data, 'type', type)
    let groups = data.map((item)=> {
        return item[type]
    })

    return Array.from(new Set(groups))
}

export const getLineChartData = (data, type, column) => {
    return data.filter((item)=> {
        return item[column] === type 
    }).map((item)=> {
        return item.total
        //return parseInt(item.total)
    })
}



export const groupReturnedObject = (objectArray, property, group, notAddGroup) => {
  let obj = {}
  return objectArray.reduce( (acc, obj, currentIndex) => {
    var key = obj[property];
    if (!acc[key]) {
      acc[key] = {};
    }

    if (obj.total % 1 != 0 || notAddGroup) { // has decimal for example 1.2 => need to have unit test for this
      acc[key][obj[group]] =  obj.total;
    } else {
      acc[key][obj[group]] =  numeral(obj.total).format('0,0');
    }
    if(!notAddGroup) {
      acc[key].Group =  `${currentIndex}`;
    }
    return acc;
  }, {});
}

export const makeObjtoArrayTableData = (inputObject, column) => {
  let outcome = []
  Object.entries(inputObject).forEach(([key, value]) => {
    let tmp = {};
    tmp[column] = key

    let another =  {...tmp, ...value}
    outcome.push(another)
    //console.log('tmp', tmp, 'value', value, 'another', another); 
    });
  return outcome;
}

export const chartHouseholdSize = (data, type) => {
  //console.log('Group households', getLineChartData(data, 'Group households', 'category'))

  let chartData =  {
      labels: getLabels(data, type),
      datasets: [
      {
          label: 'All households',
          fill: false,
          backgroundColor: '#f5222d',
          borderColor: '#f5222d',
          hoverBackgroundColor: 'rgba(0, 37, 127,0.4)',
          data: getLineChartData(data, 'All households', 'category')
      },
      {
          label: 'Family households',
          fill: false,
          backgroundColor: '#faad14', 
          borderColor: '#faad14',
          hoverBackgroundColor: 'rgba(95, 0, 127,0.4)',
          data: getLineChartData(data, 'Family households', 'category')

      },
      {
          label: 'Lone person households',
          fill: false,
          backgroundColor: '#a0d911',
          borderColor: '#a0d911',
          hoverBackgroundColor: 'rgba(127, 7, 7,0.4)',
          data: getLineChartData(data, 'Lone person households', 'category')

      },
      {
          label: 'Group households',
          fill: false,
          backgroundColor: '#eb2f96',
          borderColor: '#eb2f96',
          hoverBackgroundColor: 'rgba(127, 7, 7,0.4)',
          data: getLineChartData(data, 'Group households', 'category')

      }
      ]
  }
  return chartData;
}

export const chartHouseholdForecast = (data, type) => {
  //console.log('Group households', getLineChartData(data, 'Group households', 'category'))

  let chartData =  {
      labels: getLabels(data, type),
      datasets: [
      {
          label: 'Group households',
          fill: false,
          backgroundColor: '#f5222d',
          borderColor: '#f5222d',
          hoverBackgroundColor: 'rgba(0, 37, 127,0.4)',
          data: getLineChartData(data, 'Group households', 'category')
      },
      {
          label: 'Lone person households',
          fill: false,
          backgroundColor: '#faad14', 
          borderColor: '#faad14',
          hoverBackgroundColor: 'rgba(95, 0, 127,0.4)',
          data: getLineChartData(data, 'Lone person households', 'category')

      },
      {
          label: 'Multiple-family households',
          fill: false,
          backgroundColor: '#a0d911',
          borderColor: '#a0d911',
          hoverBackgroundColor: 'rgba(127, 7, 7,0.4)',
          data: getLineChartData(data, 'Multiple-family households', 'category')

      },
      {
          label: 'Single-family households (Couple with children)',
          fill: false,
          backgroundColor: '#eb2f96',
          borderColor: '#eb2f96',
          hoverBackgroundColor: 'rgba(127, 7, 7,0.4)',
          data: getLineChartData(data, 'Single-family households (Couple with children)', 'category')

      },
      {
          label: 'Single-family households (Couple without children)',
          fill: false,
          backgroundColor: '#13c2c2',
          borderColor: '#13c2c2',
          hoverBackgroundColor: 'rgba(127, 7, 7,0.4)',
          data: getLineChartData(data, 'Single-family households (Couple without children)', 'category')

      },
      {
          label: 'Single-family households (Other family households)',
          fill: false,
          backgroundColor: '#1890ff',
          borderColor: '#1890ff',
          hoverBackgroundColor: 'rgba(127, 7, 7,0.4)',
          data: getLineChartData(data, 'Single-family households (Other family households)', 'category')

      },
      {
          label: 'Single-family households (Single parent)',
          fill: false,
          backgroundColor: '#722ed1',
          borderColor: '#722ed1',
          hoverBackgroundColor: 'rgba(127, 7, 7,0.4)',
          data: getLineChartData(data, 'Single-family households (Single parent)', 'category')

      }
      ]
  }
  return chartData;
}

export const chartDataVertical = (data, type) => {
  //console.log('chartDataVertical', getLabels(data, type), getMale(data), getFemale(data))

  let chartData =  {
      labels: getLabels(data, type),
      datasets: [
      {
          label: 'Males',
          fill: false,
          backgroundColor: 'rgb(0, 74, 255)',
          borderColor: 'rgb(0, 59, 204)',
          hoverBackgroundColor: 'rgba(0, 37, 127,0.4)',
          data: getLineChartData(data, 'Males', 'population')
      },
      {
          label: 'Females',
          fill: false,
          backgroundColor: 'rgb(190, 0, 255)', 
          borderColor: 'rgb(152, 0, 204)',
          hoverBackgroundColor: 'rgba(95, 0, 127,0.4)',
          data: getLineChartData(data, 'Females', 'population')

      },
      {
          label: 'Persons',
          fill: false,
          backgroundColor: 'rgb(255, 15, 14)',
          borderColor: 'rgb(204, 12, 11)',
          hoverBackgroundColor: 'rgba(127, 7, 7,0.4)',
          data: getLineChartData(data, 'Persons', 'population')

      }
      ]
  }
  return chartData;
}



// WEBPACK FOOTER //
// ./src/chart/config.js